import {
    Layout,
    Alert,
    Collapse,
    Form,
    AutoComplete,
    Input,
    Row,
    Col,
    Select,
    Checkbox,
    Button,
    message,
    Radio,
    Upload,
} from "antd";
import { UploadOutlined } from '@ant-design/icons';

export default function VendorFinalisation({vendors, vendorSelected, handleOnChangeVendorSelected, handleOnchangeBiddingHdr}) {
    const { Option } = Select;
    return (
        <>
            <Row gutter={10} className="mb-1">
                <Col>
                    <Form.Item
                        label="Selected Vendor"
                        name="selected_vendor"
                        rules={[
                            {
                                required: true,
                                message: "Please input",
                            },
                        ]}>
                        <Select placeholder="Select an option" value={vendorSelected} onChange={(value) => handleOnChangeVendorSelected(value)}>
                            {vendors.map((vendor, index) => (
                                <Option key={index} value={vendor.id}>{vendor.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col>
                    <Form.Item
                        label="Value"
                        name="selected_vendor_value"
                        rules={[
                            {
                                required: true,
                                message: "Please input",
                            },
                        ]}>
                        <Input disabled={true} value={vendorSelected?.grand_total}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={10} className="mb-1">
                <Col span={12}>
                    <Form.Item
                        label="Additional Information"
                        name="vendor_additional_info"
                        rules={[{ message: "Please input" }]}>
                        <Input.TextArea rows={4} onChange={(e)=>handleOnchangeBiddingHdr("additional_information", e.target.value)}></Input.TextArea>
                    </Form.Item>
                </Col>
            </Row>
            <div>
                <h4>Attachment</h4>
                <Form.Item
                    name="attachment"
                    valuePropName="fileList"
                    getValueFromEvent={e => Array.isArray(e) ? e : e && e.fileList}
                    rules={[{ required: true, message: "Please upload a file" }]}
                >
                    <Upload beforeUpload={() => false} multiple>
                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                </Form.Item>
            </div>
        </>
    )
}